<template>
  <main>
    <vue-litebox v-if="showLitebox"
        :items="images"
        @close="hideLitebox">
    </vue-litebox>
    <section class="banner banner--home">
      <div class="container">
              <img src="../assets/perso/header_img.png" alt="Truckermatching.com">

                  <a type="button" @click="showLitebox=true">
                  <img class="play" src="../assets/Play.png"/></a>

      </div>
      <div class="mask"></div>
    </section>
       <!-- slider components -->
    <Carousel/>
    <!-- USP'S components -->
    <usps :usps="home.usps" :mobile="mobile" />

    <!-- Banner -->
    <section class="banner banner--model">
      <div class="container prof2">
      <div class="container prof1">
        <div class="inner">
       
          <div class="item case">
            <h3 v-html="home.requestDemo.title"></h3>
            <router-link :to="'/case/prime'" class="cta">{{ home.requestDemo.cta }}</router-link>
          </div>
          
        </div>
        
      </div>
      </div>
      <div class="mask"></div>
    </section>

    <!-- Banner Form -->
    <section class="banner banner--form">
      <div class="container">
        <div class="intro form">
        
                  <img id="hittheroad" src="../assets/Hit_the_road.png" alt="Let's hit the road" width="200">

            
            <!-- Form request components -->
            <form-request 
              :originForm="section"
              :ctaLabel="home.formRequestPaper.cta">
            </form-request>
          
        </div>
      </div>
      <div class="mask"></div>
    </section>

  </main>
</template>

<script>
import Home from '@/contents/homepage.json'
import Carousel from '@/components/Carousel.vue'
import Usps from '@/components/UspsDark.vue'
import FormRequest from '@/components/Form.vue'
import VueLitebox from 'vue-litebox'

export default {
  components: {
    Carousel,
    Usps,
    FormRequest,
    VueLitebox
  },
  name: 'Homepage',
  props: ['mobile'],
  data () {
    return {
      section: this.$options.name,
      home: Home,
      showLitebox: false,
      images: [
        '//www.youtube.com/embed/O8z2DPdnFfo?autoplay=1&controls=0&playsinline=1&rel=0'
      ]
    }
  },
  methods: {
    showLitebox () {
      this.showLitebox = true
    },
    hideLitebox () {
      this.showLitebox = false
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    // emit origin of form
    this.$bus.$emit('origin-form', this.section)
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Home.vue